import MenuIcon from '@mui/icons-material/Menu';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import { defaultTheme, ThemeType, useLocalTheme } from '../../../hooks/useLocalTheme';
import { DARK_BLACK } from '../../../types/core/color.types';
import { AppBar } from './NavMenu.styles';
import { NavMenuProfile } from './NavMenuProfile';

interface Props {
  open: boolean;
  toggleDrawer: () => void;
}

export function NavMenu({ open, toggleDrawer }: Props) {
  const { localTheme } = useLocalTheme();

  return (
    <AppBar
      position="fixed"
      open={open}
      style={{
        backgroundColor:
          localTheme === ThemeType.DARK ? DARK_BLACK : defaultTheme.palette.primary.contrastText,
      }}
    >
      <Toolbar>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={toggleDrawer}
          edge="start"
          sx={{
            marginRight: '36px',
            ...(open && { display: 'none' }),
          }}
        >
          <MenuIcon />
        </IconButton>
        <NavMenuProfile />
      </Toolbar>
    </AppBar>
  );
}
